import {Icon, Tag, Tooltip} from 'antd';
import React from 'react';

export const POSITIONING_LEG_TOOLTIP =
    'A positioning leg moves the aircraft between locations without carrying PAX or CGO, usually to reach the next required departure.';

/**
 * Shared explanation for empty route legs shown by both the generated-route
 * preview and the persisted flight editor.
 */
export default function PositioningLegTag() {
    return (
        <Tooltip title={POSITIONING_LEG_TOOLTIP}>
            <Tag color="gold" aria-label={`Positioning: ${POSITIONING_LEG_TOOLTIP}`}>
                <Icon type="warning"/> Positioning
            </Tag>
        </Tooltip>
    );
}
